// bao migrate skip
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import StringUtils from "../../services/bao-utils";

class AbsentDaysForShiftGroupReportViewModel {
    constructor(parent: any) {
        this.parent = parent;
        this._initialized = false;
    }
    parent: any;
    Bao = Bao;
    private _initialized: boolean;
    ShiftGroupId: KnockoutObservable<string> = ko.observable("");
    ShiftGroupName: KnockoutObservable<string> = ko.observable("");
    Years: KnockoutObservableArray<number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<number> = ko.observable(null);
    HolidayDataForShiftGroup: KnockoutObservableArray<any> = ko.observableArray([]);
    /** true if the report has loaded data, false otherwise
     */
    ReportLoaded: KnockoutObservable<boolean> = ko.observable(false);
    /** true if the report has loaded at least once
     */
    ReportRequested: KnockoutObservable<boolean> = ko.observable(false);
    /** true if the report has loaded and no data are available, false otherwise
     */
    IsReportResultEmpty: KnockoutComputed<boolean> = ko.pureComputed(() => { return (this.ReportLoaded() === false) && this.ReportRequested(); });
    Download() {
        if (StringUtils.String.IsNullOrWhitespace(this.ShiftGroupId()) || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/AbsentDaysForShiftGroupReportDownload", JSON.stringify({
                shiftGroupId: this.ShiftGroupId(),
                year: this.SelectedYear(),
                reportTemplateId: null
            }), (result) => {
                this.parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    }
    GetReport() {
        if (StringUtils.String.IsNullOrWhitespace(this.ShiftGroupId()) || this.SelectedYear() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.ReportLoaded(false);
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/AbsentDaysForShiftGroupReportGetReport", JSON.stringify({
                shiftGroupId: this.ShiftGroupId(),
                year: this.SelectedYear(),
                reportTemplateId: null
            }), (result) => {
                if (result.Result) {
                    this.HolidayDataForShiftGroup(result.Value);
                    this.ReportLoaded(true);
                }
                this.parent.TabPage.IsLoading(false);
                this.ReportRequested(true);
            });
        }
    }
    init() {
        return Bao.post("SynosetReportCenter/AbsentDaysForShiftGroupReportGetDefaultData", (result) => {
            ko.map.fromJS(result, this);
            this._initialized = true;
        });
    }
    ;
    loaded() {
        //Dashboard laden
        var currentDate = new Date();
    }
    ;
}
export default AbsentDaysForShiftGroupReportViewModel;